module.exports = __webpack_public_path__ + "static/media/worksheet-type.3d6f3365.svg";